import { gql } from '@apollo/client';
const GET_PRODUCT_CATEGORIES = gql `
  query GetProductCategories {
    autocomplete {
      productCategories {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            type
            typeLabelPL
            typeLabelEN
            typeIcon
            displayOrder
            filtersAvailable
            productsCount
          }
        }
      }
    }
  }
`;
export default GET_PRODUCT_CATEGORIES;
